<template>
  <div class="step-locate-wrapper">
    <div class="step-locate">
      <div v-if="step === 2" class="step-locate-item" :class="{active: step === 2}">
        <div class="locate-text">
          <button @click="returnStep1()" class="btn-step-locate"><i class="fas fa-angle-left"></i>
            {{ $t('message.backToInit') }}
          </button>
        </div>
      </div>
      <div class="step-locate-item" v-if="step === 3" :class="{active: step === 3}">
        <div class="locate-text">
          <button @click="returnStep2()" class="btn-step-locate"><i class="fas fa-angle-left"></i>
             {{ $t('message.backToContact') }}
          </button>
        </div>
      </div>
      <div class="step-locate-item" v-if="step === 4" :class="{active: step === 4}">
        <div class="locate-text">
          <button @click="returnCart()" class="btn-step-locate"><i class="fas fa-angle-left"></i>
             {{ $t('カートに戻る') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyStepLocate',
  props: {
    step: {
      type: Number,
      default: 1
    }
  },
  methods: {
    returnStep1 (e) {
      if (confirm(this.$root.$t('入力した内容を全て破棄して、申込のトップ画面に戻ります。'))) {
        let resetUrl = '/reserve-app/?ui=' + this.$root.$store.state.userId + '&'
        if (this.$root.$route.query.email !== undefined) {
          resetUrl += '&email=' + this.$root.$route.query.email
        }
        if (this.$root.$route.query.dev !== undefined) {
          resetUrl += '&dev=' + this.$root.$route.query.dev
        }
        if (this.$root.$route.query.type !== undefined) {
          resetUrl += '&type=' + this.$root.$route.query.type
        }
        if (this.$root.$route.query.int !== undefined) {
          resetUrl += '&int=' + this.$root.$route.query.int
        }

        window.sessionStorage.clear()
        console.log('resetUrl', resetUrl)
        window.location.href = resetUrl
        // this.$root.$store.commit('initState')
        // this.$root.$store.commit('update', { field: 'step', value: 1 })
      }
    },
    returnStep2 (e) {
      this.$root.$store.commit('update', { field: 'step', value: 2 })
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    returnCart (e) {
      this.$root.$store.commit('update', { field: 'step', value: 3 })
    }
  }
}
</script>
<style scoped>
.step-locate-wrapper {
  position: sticky;
  top: 0;
  background-color: transparent;
  width: 100%;
  z-index: 10;
  margin-bottom: 15px;
}
.step-locate {
  text-align: left;
}
.btn-step-locate {
  background: white;
  border: 1px solid #ccc;
  color: #0b58a2;
  cursor: pointer;
  font-size: 16px;
  padding: 10px;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.3))
}
</style>
